import T from '@/components/Helpers/Translate'
import React from 'react'

export const FdaStatementSection = () => (
  <div
    className="flex w-full items-center justify-center bg-[#5A8FC34D] px-6 py-4 text-center"
    data-test="product-key-ingredients-section"
  >
    <span className="text-sm">
      <T>fda_statement</T>
    </span>
  </div>
)
